<mp-selector-item [disabled]="disabled()" [toggleable]="false" (click)="!disabled() && onClick()">
  <div class="selected-value-container">
    <div class="selected-value-container__value">
      <ng-content />
    </div>

    <mat-icon class="material-icons-outlined">edit</mat-icon>
  </div>
</mp-selector-item>
